import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SecurityService } from './security/security.service';
import {Observable} from "rxjs";

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(private router: Router, private securityService: SecurityService) {}
  public canActivate(): Observable<boolean> {
    return this.securityService.isLoggedIn;
  }
}
